import React from 'react';
import {connect} from 'react-redux';

import './styles.scss';
import { modalViewGA } from '../../../utils/googleAnalytics';

class ConfirmClose extends React.Component {
  constructor(props){
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.closeParent = this.closeParent.bind(this);
  }

  componentDidMount(){
    modalViewGA('confirm-close');
  }

  closeModal(e){
    e.preventDefault();
    this.props.removeModal();
  }

  closeParent(){
    this.props.removeParentModal();
    this.props.removeModal();
  }

  render(){
    return (
      <div>
        <div className="modals-popup confirm-close-modal">
          <div className="modal-header d-flex align-items-center">
            <div className="col">Are you sure you want to close the window?</div>
            <div className="text-right">
              <a className="closer" href="#" onClick={this.closeModal}></a>
            </div>
          </div>

          <div className="info p-20">
            <div className="info-text">You appear to have changes in the form.
              If you close now, your changes will be lost. Are you sure you want to close the window?</div>

            <div className="row">
              <div className="col-md-6">
                <div className="btn btn-primary" onClick={this.closeModal}>Go Back</div>
              </div>
              <div className="col-md-6">
                <div className="btn btn-primary" onClick={this.closeParent}>Close</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {

  };
}

export default connect(mapStateToProps)(ConfirmClose);
